import type { EquipmentSummaryType } from "../types/connected-object";

export const getEquipmentSiteName = (
  equipment?: EquipmentSummaryType | { site?: string | { id: number; name: string } | null; siteId?: number | null } | null
): string | null => {
  if (!equipment) {
    return null;
  }

  const site = equipment.site;

  if (typeof site === "string") {
    return site;
  }

  if (site && typeof site === "object" && "name" in site) {
    return site.name;
  }

  return null;
};
